import { render, staticRenderFns } from "./PerfisUsuarios.vue?vue&type=template&id=6d8f5654&"
import script from "./PerfisUsuarios.vue?vue&type=script&lang=js&"
export * from "./PerfisUsuarios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports